import { ChangeLog, ChangeLogView } from "src/components/change-log/ChangeLog";
import { useRouteParams } from "src/hooks/useRouteParams";
import { ProjectRouteProps } from "src/Routes";

export function ProjectChangeLogPage() {
  // Then get the project id
  const { projectId } = useRouteParams<ProjectRouteProps>();

  return <ChangeLog view={ChangeLogView.Project} projectId={projectId} />;
}
